import { Component, OnInit } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexXAxis,
  ApexYAxis,
  ApexPlotOptions,
  ApexLegend
} from "ng-apexcharts";
import { take } from 'rxjs/operators';
import { COMPANYLEADCHARTDATA } from 'src/app/helpers/helperResources';
import { CompaniesService } from 'src/app/services/client-services/companies.service';
import { GeneralService } from 'src/app/services/general.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: 'app-company-report',
  templateUrl: './company-report.component.html',
  styleUrls: ['./company-report.component.css']
})

export class CompanyReportComponent implements OnInit {

  public chart_labelsMonth = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  public chart_labelsQuater = ["Q1", "Q2", "Q3", "Q4"];
  public chartOptions: Partial<ChartOptions> = {
    series: [
      {
        name: "New Companies",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
    ],
    chart: {
      type: "bar",
      height: 300
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    colors: ["#0866C6"],
    legend: {
      show: true,
      position: 'top',
      labels: {
        colors: '#0866C6',
        useSeriesColors: true
      },
    }
  };
  cOptions: Partial<ChartOptions>;
  barChartYear = 2020;
  dataSource: any;

  selectedTeamId = this.gs.teamIdSideBarFilter;
  teamID;
  userId;

  selectedType = 'selfowner';
  viewType = 'month'

  constructor(
    private companyServ: CompaniesService,
    private gs: GeneralService,
  ) {
    this.cOptions = {
      series: [
        {
          name: "New Companies",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
      ],
      xaxis: {
        categories: [...this.chart_labelsMonth],
        title: {
          text: 'New Companies',
        },
      },
      yaxis: {
        title: {
          text: `Number of Companies`,
        },
      }
    }
    this.userId = this.gs.user.id;
    this.setView();
  }

  public getNewCompaniesOverview() {
    let query = this.handleFilterByTest();
    if (query === 'self') {
      // query = `${this.getDateFilterRange}&teamId=t`
    }
    this.companyServ
      .getCompaniesByFilter(query)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          if (res) {
            this.dataSource = res.payload;
            let noIds = [0, 0];
            for (const item of this.dataSource) {
              if (!Object.keys(item).includes('teamId')) {
                noIds[0] += 1;
              }
              if (!Object.keys(item).includes('owner')) {
                noIds[1] += 1;
              }
            }


            //Chart Data
            const newCompany = COMPANYLEADCHARTDATA(this.dataSource, this.viewType);

            if (noIds[0] > 0 || noIds[1] > 0) {
              this.cOptions.xaxis = {
                categories: this.viewType === 'month' ? [...this.chart_labelsMonth] : [...this.chart_labelsQuater],
                title: {
                  text: `Data not completed.TeamId and Owner missing from data property`,
                },
              }
            }
            this.cOptions.series = [{
              name: "New Company",
              data: [...newCompany]
            }
            ];

          } else {
            this.cOptions.series = [
              {
                name: "New Company",
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
              }
            ];
          }
        },
        (error) => {
        }
      );


  }

  private get getDateFilterRange() {
    const startYr = Date.parse(
      new Date(`01/01/${this.barChartYear}`).toISOString()
    );
    const endYr = Date.parse(
      new Date(`12/31/${this.barChartYear}`).toISOString()
    );
    const jsonValueRange = {
      createdAt: { from: startYr, to: endYr },
    };
    return `range=${JSON.stringify(jsonValueRange)}`;
  }

  ngOnInit() { }

  handleFilterByTest() {
    //  = 16377 f = 
    let teamall = '16372, 16377, 16380, 16382, 16383, 16385, 16386'
    let ownerall = '16368, 16377, 16380, 16382, 16383, 16385, 16386'
    let query;

    switch (this.selectedType) {
      case 'selfowner':
        query = `${this.getDateFilterRange}&owner=${this.userId}`
        break;
      case 'selfallowner':
        query = `createdBy=${ownerall}`
        break;
      case 'selfallteam':
        query = `teamId=${teamall}`;
        break;
      default:
        query = `self`;
        break;
    }
    return query;
  }

  setView() {
    if (this.viewType === 'month') {
      this.cOptions.xaxis = {
        categories: [...this.chart_labelsMonth],
        title: {
          text: 'New Companies',
        },
      }
    } else {
      this.cOptions.xaxis = {
        categories: [...this.chart_labelsQuater],
        title: {
          text: 'New Companies',
        },
      }
    }
    this.getNewCompaniesOverview();

  }



}
